import { storageDecoratorGetHandler } from './session-storage';

/**
 * localStorage
 *
 * @param key å­å¨çé®åï¼ä¸æä¾åä½¿ç¨å±æ§å
 * @param defaultValue ç¼å­æ²¡ææ¾å°å¼æ¶ä½¿ç¨çé»è®¤å¼
 */
export function LocalStorage(key?: string, defaultValue?: any): (target: any, propName: string) => void;

/**
 * localStorage
 *
 * @param config å¯¹è±¡å½¢å¼ç keyãdefaultValueï¼æ¹ä¾¿çç¥ key åªå®ä¹ defaultValue çæåµï¼
 * æ¯å¦ï¼@SessionStorage({ defaultValue: xxx })
 */
export function LocalStorage(config?: { key?: string, defaultValue?: any }): (target: any, propName: string) => void;

export function LocalStorage(key?: string | { key?: string, defaultValue?: any }, defaultValue?: any) {
    return function (target: any, propName: string) {
        let rawKey: string;
        let cache: any;

        if (typeof key === 'string') {
            rawKey = key;
        } else if (key !== null && typeof key === 'object' && typeof key.key === 'string') {
            rawKey = key.key;
        } else {
            rawKey = propName;
        }

        Object.defineProperty(target, propName, {
            get() {
                return storageDecoratorGetHandler(cache, localStorage.getItem(rawKey), key, defaultValue);
            },
            set(value: any) {
                cache = value;
                localStorage.setItem(rawKey, JSON.stringify(value));
            }
        });
    };
}